import {
  SEARCH_NOTIFICATION_RULES_REQUEST,
  SEARCH_NOTIFICATION_RULES_SUCCESS,
  SEARCH_NOTIFICATION_RULES_FAILURE,
  GET_LIST_NOTIFICATIONS_RULE_REQUEST,
  GET_LIST_NOTIFICATIONS_RULE_SUCCESS,
  GET_LIST_NOTIFICATIONS_RULE_FAILURE,
  GET_ONE_NOTIFICATION_REQUEST,
  GET_ONE_NOTIFICATION_SUCCESS,
  GET_ONE_NOTIFICATION_FAILURE,
  UPDATE_NOTIFICATION_REQUEST,
  CREATE_NOTIFICATION_SUCCESS,
  CREATE_NOTIFICATION_FAILURE,
  CREATE_NOTIFICATION_REQUEST,
  UPDATE_NOTIFICATION_SUCCESS,
  UPDATE_NOTIFICATION_FAILURE,
  UPDATE_ACTIVE_COMMENT_REQUEST,
  UPDATE_ACTIVE_COMMENT_SUCCESS,
  UPDATE_ACTIVE_COMMENT_FAILURE,
  DELETE_NOTIFICATION_REQUEST,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAILURE,
  GET_LIST_STATE_REQUEST,
  GET_LIST_STATE_SUCCESS,
  GET_LIST_STATE_FAILURE,
  GET_LIST_PAYMENT_METHOD_REQUEST,
  GET_LIST_PAYMENT_METHOD_SUCCESS,
  GET_LIST_PAYMENT_METHOD_FAILURE
} from "src/actions/orderNotificationActions";
import _ from "lodash";
import produce from "immer";

const initialState = {
  listState: [],
  listPaymentMethod: [],
  notifications: [],
  notification: {},
  total: 0,
  loadingGetNotifications: false,
  loadingGetOneNotification: false,
  loadingUpdateNotification: false,
  loadingUpdatePermissionOfNotification: false,
  loadingUpdateActiveNotification: false,
  loadingDeleteNotification: false,
  loadingGetListState: false
};

const orderNotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_NOTIFICATION_RULES_REQUEST: {
      return produce(state, (draft) => {
        draft.notifications = [];
        draft.loadingGetNotifications = true;
      });
    }

    case SEARCH_NOTIFICATION_RULES_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.notifications = response;
        draft.loadingGetNotifications = false;
        draft.total = total;
      });
    }

    case SEARCH_NOTIFICATION_RULES_FAILURE: {
      return produce(state, (draft) => {
        // Maybe notification error
        draft.loadingGetNotifications = false;
      });
    }

    // Case Get notifications
    case GET_LIST_NOTIFICATIONS_RULE_REQUEST: {
      return produce(state, (draft) => {
        draft.notifications = [];
        draft.loadingGetNotifications = true;
      });
    }

    case GET_LIST_NOTIFICATIONS_RULE_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.notifications = response;
        draft.loadingGetNotifications = false;
      });
    }

    case GET_LIST_NOTIFICATIONS_RULE_FAILURE: {
      return produce(state, (draft) => {
        // Maybe notification error
        draft.loadingGetNotifications = false;
      });
    }

    // Case Get One Comment
    case GET_ONE_NOTIFICATION_REQUEST: {
      return produce(state, (draft) => {
        draft.notification = {};
        draft.loadingGetOneNotification = true;
      });
    }

    case GET_ONE_NOTIFICATION_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.notification = response;
        draft.loadingGetOneNotification = false;
      });
    }

    case GET_ONE_NOTIFICATION_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetOneNotification = false;
      });
    }

    // Case Update Comment
    case UPDATE_NOTIFICATION_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingUpdateNotification = true;
      });
    }

    case UPDATE_NOTIFICATION_SUCCESS: {
      const {response} = action.payload;
      const updateNotification = _.map(state.notifications, (i) => {
        if (i.id === response.id) return response;
        return i;
      });
      if (updateNotification !== undefined && updateNotification.length > 0) {
        return produce(state, (draft) => {
          draft.notifications = updateNotification;
          draft.loadingUpdateNotification = false;
        });
      }
      return produce(state, (draft) => {
        draft.notifications = [response];
        draft.loadingUpdateNotification = false;
      });
    }
    // Create
    case CREATE_NOTIFICATION_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case CREATE_NOTIFICATION_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.notifications = [...draft.notifications, response];
        draft.loading = false;
      });
    }

    case CREATE_NOTIFICATION_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case UPDATE_NOTIFICATION_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingUpdateNotification = false;
      });
    }

    // Case Update Active Comment
    case UPDATE_ACTIVE_COMMENT_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingUpdateActiveComment = true;
      });
    }

    case UPDATE_ACTIVE_COMMENT_SUCCESS: {
      const {response} = action.payload;
      const updateComment = _.map(state.comments, (i) => {
        if (i.id === response.id) return response;
        return i;
      });
      if (updateComment !== undefined && updateComment.length > 0) {
        return produce(state, (draft) => {
          draft.comments = updateComment;
          draft.loadingUpdateActiveComment = false;
        });
      }
      return produce(state, (draft) => {
        draft.comments = [response];
        draft.loadingUpdateActiveComment = false;
      });
    }

    case UPDATE_ACTIVE_COMMENT_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingUpdateActiveComment = false;
      });
    }

    // Case Delete Comment
    case DELETE_NOTIFICATION_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingDeleteNotification = true;
      });
    }

    case DELETE_NOTIFICATION_SUCCESS: {
      const {response} = action.payload;
      const deleteNotificaton = _.filter(state.notifications, (i) => i.id !== response);
      if (deleteNotificaton !== undefined && deleteNotificaton.length > 0) {
        return produce(state, (draft) => {
          draft.notifications = deleteNotificaton;
          draft.loadingDeleteNotification = false;
        });
      }
      return produce(state, (draft) => {
        draft.notifications = [];
        draft.loadingDeleteNotification = false;
      });
    }

    case DELETE_NOTIFICATION_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetListState = false;
      });
    }
    // CASE GET LIST STATE
    case GET_LIST_STATE_REQUEST: {
      return produce(state, (draft) => {
        draft.listState = [];
        draft.loadingGetListState = true;
      });
    }

    case GET_LIST_STATE_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.listState = response;
        draft.loadingGetListState = false;
      });
    }

    case GET_LIST_STATE_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetNotifications = false;
      });
    }
    // CASE GET LIST PAYMENT METHOD
    case GET_LIST_PAYMENT_METHOD_REQUEST: {
      return produce(state, (draft) => {
        draft.listPaymentMethod = [];
        draft.loadingGetListState = true;
      });
    }

    case GET_LIST_PAYMENT_METHOD_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.listPaymentMethod = response;
        draft.loadingGetListState = false;
      });
    }

    case GET_LIST_PAYMENT_METHOD_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetNotifications = false;
      });
    }

    default: {
      return state; // We return the default state here
    }
  }
};

export default orderNotificationReducer;
